export default __webpack_public_path__ + "static/media/TOTP.489ff58c.png";